
import { Vue, Component } from "vue-property-decorator";
import NewsItem from "./components/news-item.vue";
import request from "@/api/index";
import { List as vanList } from "vant";
import { wxChatShare } from "@/common/wechat";
import { VideoNewsItem } from "@/api/types";

@Component({
  name: "djVideoNews",
  components: {
    vanList,
    NewsItem
  }
})
export default class djVideoNews extends Vue {
  videoNews: VideoNewsItem[] = [];
  finished: boolean = false;
  isLoading: boolean = false;
  created() {
    this.getList();
    document.title = "垫江新闻";
    const ua: string = navigator.userAgent.toLowerCase();
    const returns: RegExpMatchArray | null = ua.match(/MicroMessenger/i);
    if (returns !== null && returns[0] === "micromessenger") {
      wxChatShare(
        "垫江新闻",
        "这是一档“立足垫江， 关注时事，传播资讯，服务发展”的综合性新闻节目。",
        window.location.href,
        "https://imagecdn.cqliving.com/images/icon/18.png"
      );
    }
  }

  async getList(
    lastId?: string | number,
    lastSortNo?: string | number,
    lastOnlineTime?: string
  ) {
    const result = await request.getNewsList(
      "18",
      "28035",
      lastId,
      lastSortNo,
      lastOnlineTime
    );
    if (result.code >= 0) {
      if (lastId) {
        if (result.data.news && result.data.news.length > 0) {
          this.videoNews = this.videoNews.concat(result.data.news);
        } else {
          this.finished = true;
        }
      } else {
        this.videoNews = result.data.news;
      }
    }
    this.isLoading = false;
  }

  onListLoad() {
    if (this.videoNews.length == 0) {
      return;
    }
    const lastEl: VideoNewsItem = this.videoNews.lastChild;
    const lastId = lastEl.id;
    const lastSortNo = lastEl.sortNo;
    const lastOnlineTime = lastEl.onlineTime;
    this.getList(lastId, lastSortNo, lastOnlineTime);
  }
}
